// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"g_r ml-3","matrix-table--pad4":"g_s ml-5","matrix-table__title":"g_t","matrix-table__true":"g_v","matrix-table__false":"g_w"};